import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
// import { Users, Star } from "react-feather";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faDoorOpen,
  faEdit,
  faPlus,
  faSort,
  faTowerObservation,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import clientlogo from "../assets/img/user1.jpg";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link, useLocation } from "react-router-dom";
import ReactDOM from "react-dom";
import house from "../assets/img/house.png";
import notice from "../assets/img/notice.png";
import building from "../assets/img/building.png";
import office from "../assets/img/office.png";
import apartment from "../assets/img/apartment.png";
import gate from "../assets/img/gate.png";
import Menus from "./menus";
import Noticemanagement from "./Noticemanagement";
// import NoticeApproval from "./NoticeApproval";
import Building from "./building";
import Tower from "./tower";
import Flat from "./flat";
import Gate from "./Gate";
import Resident from "./Resident";
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
// import Nodata from "../assets/img/NoData.png";
import ServiceIcon from "../assets/img/ss-submenu.png";
import SocietyIcon from "../assets/img/society-submenu.png";
import DepartmentIcon from "../assets/img/department-submenu.png";
import SubcategoryIcon from "../assets/img/subcategory-submenu.png";
import CategoryIcon from "../assets/img/category-submenu.png";
import Category from "./Category";
import Subcategory from "./Subcategory";
import Department from "./Department";
import SocietyRole from "./SocietyRole";
import ServiceStaff from "./ServiceStaff";
import AccessControlType from "./AccessContolType";
import GroupGate from "./GroupGate";


function SystemSetting() {
  const history = useNavigate();
  const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)
  const [activeTab, setActiveTab] = useState("tab1");
  const [UserData, setUserData] = useState("");
  const location = useLocation();
  //const data = location.state
  console.log("dataParms", location)
  const handleTabChange = (tab) => {
    localStorage.setItem("lastTabSystem", tab)
    setActiveTab(tab);
  };
  const [reset, setReset] = useState(0);


  // useEffect(()=>{
  //   const auth = localStorage.getItem("userData");
  //   const myUserData = JSON.parse(auth);
  //   console.log(myUserData,"USERDATA")
  //   console.log(myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin","DATATA")
  //   if(myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin"){
  //     history('/Dashboard');
  //     // alert("Hello")
  //   }

  // },[])

  useEffect(() => {
    localStorage.setItem("lastTab", "tab1")
    localStorage.setItem("lastTabApproval", "tab1")
    localStorage.setItem("lastTabUtility", "tab1")
    const lastTab = localStorage.getItem("lastTabSystem");
    if (!lastTab) {
      setActiveTab("tab1")
    }
    else {
      setActiveTab(lastTab)
    }

  }, [])

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    setUserData(myUserData);
    console.log("useEffect Local storage name", storedUsername)
    console.log("Role Name", myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin")
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if (myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator") {
        if (myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator") {
          history('/SystemSetting');
          return
        } else {
          history('/Dashboard');
        }
      } else {
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        return
      }
    }
    else if (storedUsername === null) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  return (
    <>
      <Menus />
      <section className="tabular_intergration">
        <div className="tab-container">
          <div className="UnderBox-Shadow">
            <div className="container-fluid py-0 px-0 hideContainer">
              <div className="row">
                <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                  <div className="tabs d-flex">
                    <button
                      className={activeTab === "tab1" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab1")}
                    >
                      <img src={CategoryIcon} className="img" style={{ width: "21px", marginRight: "5px" }} />{""}
                      Category
                    </button>
                    <button
                      className={activeTab === "tab2" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={SubcategoryIcon} className="img" style={{ width: "21px", marginRight: "5px" }} />{""}
                      Sub-Category

                    </button>
                    {UserData?.roleName == "Super Admin" || UserData?.roleName == "Support Admin" ?
                      <button
                        className={activeTab === "tab3" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                        onClick={() => handleTabChange("tab3")}
                      >
                        <img src={DepartmentIcon} className="img" style={{ width: "21px", marginRight: "5px" }} />{""}
                        Department

                      </button>
                      :null
                    }  
                    <button
                      className={activeTab === "tab4" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab4")}
                    >
                      <img src={SocietyIcon} className="img" style={{ width: "21px", marginRight: "5px" }} />{""}
                      Society Role

                    </button>
                    <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={ServiceIcon} className="img" style={{ width: "21px", marginRight: "5px" }} />{""}
                      Service Staff

                    </button>
                    {/* <button
                  className={activeTab === "tab6" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab6")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Access control Type

                </button> */}
                {/* <button
                  className={activeTab === "tab7" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab7")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Group Gate

                </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mobileViewSubMenu" style={{ width: "100%" }}>
        <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
          {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
          {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
        </div>
        <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
          <div className="row">
            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
              <div className="tabs">
                <button
                  className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab1")}
                >
                  <img src={house} className="img" style={{ width: "21px" }} />{""}
                  Category
                </button>
                <button
                  className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab2")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Sub-Category

                </button>
                {UserData?.roleName == "Super Admin" || UserData?.roleName == "Support Admin" ?
                <button
                  className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab3")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Department

                </button>
                :null
                }
                <button
                  className={activeTab === "tab4" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab4")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Society Role

                </button>
                <button
                  className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab5")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Service Staff

                </button>
                {/* <button
                  className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab6")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Access control Type

                </button> */}
                {/* <button
                  className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab7")}
                >
                  <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                  Group Gate

                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="OneClr_apply">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">


              {activeTab === "tab1" && (
                <div>
                  <Category />
                </div>
              )}
              {activeTab === "tab2" && (
                <div>
                  <Subcategory />
                </div>
              )}
              {activeTab === "tab3" && (
                <div>
                  <Department />
                </div>
              )}
              {activeTab === "tab4" && (
                <div>
                  <SocietyRole />
                </div>
              )}
              {activeTab === "tab5" && (
                <div>
                  <ServiceStaff />
                </div>
              )}
               {/* {activeTab === "tab6" && (
                <div>
                  <AccessControlType />
                </div>
              )} */}
               {/* {activeTab === "tab7" && (
                <div>
                  <GroupGate />
                </div>
              )} */}
              {/* {activeTab === "tab2" && (
                <div>
                  <NoticeApproval />
                </div>
              )}
   */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SystemSetting;
